<i18n lang='yml' src='../i18n/ProgramStandardForm.yml'></i18n>
<template>
  <div>
    <flash :message_type="message_type" :message_text="message_text"/>
      <Form ref="observer" v-slot="{ errors }" @submit="submitUserInput" @invalid-submit="setErrorMessage">
          <fieldset class="form-group border-bottom">
            <div class="form-group">
              <label> {{$t('version.label')}} </label>
              <span class="red">*</span>
              <Field
                :name="$t('version.label')" 
                rules="required"
                v-slot="{ errors, field }"
                v-model="programStandard.version">
                <input :class="{'is-invalid': errors[0]}" 
                  name="version" 
                  type="text " 
                  class="form-control" 
                  v-bind="field">
                <div class="invalid-feedback" :id="`${$t('version.label')}_error`" v-if="errors[0]">
                  <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                  <span>{{ errors[0] }}</span> 
                </div>
              </Field>
            </div>
          </fieldset>
           
          <fieldset class="form-group border-bottom">
            <p class="mb-2"> {{$t('status.guide_text')}}</p>
            <div  class="form-check form-check-inline" :class="{'is-invalid': errors[$t('status.label')]}">
             <label class="form-check-label">
              <Field
                :name="$t('status.label')" 
                :rules="type == 'edit' ? '' : 'required'"
                v-model="programStandard.status"
                :id="$t('status.label')"  
                value="true"
                type="radio"/>
              {{$t('status.label')}}
              </label>
              <span class="red">*</span>
            </div>
            <div v-if="errors[$t('status.label')]"  class="invalid-feedback"  :id="`${$t('status.label')}_error`" >
              <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
              <span>{{errors[$t('status.label')] }}</span> 
            </div>
          </fieldset> 

          <fieldset class="form-group border-bottom">
            <legend>
              {{$t('program_standards')}}
            </legend>
            <fieldset class="mb-3">
              <legend> {{$t('tracking_section.header')}} 
                <span class="red">*</span>
              </legend>
              <p class="mb-2"> {{$t('tracking_section.guide_text')}}</p>
              <div class="alert alert-info help-block">
                <font-awesome-icon :icon="['fa', 'info-circle']" />
                <span class="pl-2">{{ $t('tracking_section.alert') }}</span> 
              </div>
              <div class="form-group form-check mb-2">
                <Field
                  :name="$t('tracking_section.skills_tracking')"
                  :rules="`at_least_one_checked:@${$t('tracking_section.hours_tracking')},@${$t('tracking_section.skills_tracking')}`"
                  v-slot="{ errors, field}" 
                  v-model="programStandard.skills_tracking"
                  :value="true" 
                  :unchecked-value="false"
                  type="checkbox">
                  <input 
                   :value="true" 
                   :class="{'is-invalid': errors[0]}" 
                    class="form-check-input" type="checkbox" 
                    :name="$t('tracking_section.skills_tracking')"
                    @click="isSkillsDisabled"
                    v-bind="field">
                  <div class="d-md-flex" :class="{'is-invalid': errors[0]}">
                    <label class="form-check-label" for="skills_tracking">{{ $t('tracking_section.skills_tracking') }}</label>   
                  </div>
                </Field>           
              </div>
              <div class="form-group form-check mb-4">
                <Field
                  :name="$t('tracking_section.hours_tracking')"
                  :rules="`at_least_one_checked:@${$t('tracking_section.hours_tracking')},@${$t('tracking_section.skills_tracking')}`"
                  v-slot="{ errors, field }"
                  v-model="programStandard.hours_tracking"
                  :value="true" 
                  :unchecked-value="false"
                  type="checkbox" >
                  <input 
                    :value="true" 
                    :class="{'is-invalid': errors[0]}" 
                    class="form-check-input"
                    :name="$t('tracking_section.hours_tracking')"  
                    @click="isHoursDisabled"
                    type="checkbox"   
                    v-bind="field">
                  <div class="d-md-flex" :class="{'is-invalid': errors[0]}">
                    <label class="form-check-label" for="hours_tracking">{{ $t('tracking_section.hours_tracking') }}</label>
                  </div>
                  <div class="invalid-feedback" :id="`${$t('tracking_section.hours_tracking')}_error` || `${$t('tracking_section.skills_tracking')}_error` " v-if="errors[0]">
                    <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                    {{ $t('tracking_section.alert') }}
                  </div>       
                </Field> 
              </div>    
            </fieldset>

            <fieldset class="form-group border-bottom mb-4">
              <legend> {{$t('hours_section.header')}}</legend>
              <p class="mb-2">{{$t('hours_section.guide_text')}}</p>
                <div class="form-group form-inline row">     
                  <div class="col-sm-12">
                    <Field 
                      :name="$t('hours_section.on_job_hours')"
                      :rules="{required: true,decimal_places:2,between: [0, 1000000]}"
                      v-slot="{ errors, field }"
                      v-model="programStandard.job_hours" >
                      <label class="col-sm-12 col-md-3 justify-content-start field-inline pl-0" :for="$t('hours_section.on_job_hours')"> {{$t('hours_section.on_job_hours')}}</label>
                      <div class="col-sm-12 col-md-5 col-lg-4 col-xl-3 field-inline">
                        <input :id="$t('hours_section.on_job_hours')" 
                          name="job_hours"
                          class="form-control" 
                          :class="{'is-invalid': errors[0]}" 
                          v-bind="field"
                          type="number"
                          step="0.01">
                        <div class="invalid-feedback" id="job_hours_error" v-if="errors[0]">
                          <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                          <span>{{ errors[0] }}</span> 
                        </div>
                      </div>
                    </Field>  
                  </div>
                </div>
                <div class="form-group form-inline row">
                  <div class="col-sm-12">
                    <Field 
                      :name="$t('hours_section.class_hours')"
                      :rules="{required: true, between: [0, 1000000], decimal_places: 2}"
                      v-slot="{ errors, field }"
                      v-model="programStandard.class_hours" >
                      <label class="col-sm-12 col-md-3 justify-content-start field-inline pl-0" :for="$t('hours_section.class_hours')"> {{$t('hours_section.class_hours')}}</label>
                      <div class="col-sm-12 col-md-5 col-lg-4 col-xl-3 field-inline">
                        <input :id="$t('hours_section.on_job_hours')" 
                          name="class_hours"
                          class="form-control" 
                          :class="{'is-invalid': errors[0]}" 
                          v-bind="field"
                          type="number"
                          step="0.01">
                        <div class="invalid-feedback" id="class_hours_error" v-if="errors[0]">
                          <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                          <span>{{ errors[0] }}</span> 
                        </div>
                      </div>
                    </Field> 
                  </div>
                </div>
                <div class="form-group form-inline row">
                  <div class="col-sm-12">
                    <label class="col-sm-12 col-md-3 justify-content-start field-inline pl-0">{{$t('hours_section.total_hours')}}</label>
                    <div class="col-sm-12 col-md-5 col-lg-4 col-xl-3 field-inline">
                      <input
                        inputId="total_hours"
                        name="total_hours"
                        v-model="getTotalHours"
                        class="form-control"
                        readonly
                      /> 
                    </div>
                  </div>        
                </div> 
            </fieldset>
            <fieldset>
              <legend>{{$t('requirements_section.header')}}
                <span class="red">*</span>
              </legend>
              <p class="mb-2">{{$t('requirements_section.guide_text')}}</p>
              <div class="alert alert-info help-block">
                <font-awesome-icon :icon="['fa', 'info-circle']" />
                <span class="pl-2">{{ $t('requirements_section.alert') }}</span> 
              </div>
              <div class="form-group form-check mb-2">
                <Field 
                  :name="$t('requirements_section.mandatory_skills')"
                  :rules="`at_least_one_checked:@${$t('requirements_section.mandatory_skills')},@${$t('requirements_section.program_hours_credited')}`"
                  v-slot="{ errors,field }"
                  v-model="programStandard.skill_requirement" 
                  :value="true" 
                  :unchecked-value="false"
                  type="checkbox">
                  <div class="d-md-flex" :class="{'is-invalid': errors[0]}">
                    <input  class="form-check-input" 
                     :value="true" 
                     :name="$t('requirements_section.mandatory_skills')" 
                     :disabled="!programStandard.skills_tracking"
                      type="checkbox" 
                      v-bind="field">
                    <label class="form-check-label" for="skill_requirement">{{ $t('requirements_section.mandatory_skills') }}</label>
                  </div>
                </Field>
              </div>
              <div class="form-group form-check mb-2">
                <Field  
                  :name="$t('requirements_section.program_hours_credited')"
                  :rules="`at_least_one_checked:@${$t('requirements_section.mandatory_skills')},@${$t('requirements_section.program_hours_credited')}`"
                  v-slot="{ errors, field }"
                  v-model="programStandard.hours_requirement"
                  :value="true" 
                  :unchecked-value="false"
                  type="checkbox" >
                  <div class="d-md-flex" :class="{'is-invalid': errors[0]}">
                    <input  
                      :value="true" 
                      class="form-check-input" 
                      :name="$t('requirements_section.program_hours_credited')" 
                      :disabled="!programStandard.hours_tracking"
                      type="checkbox" 
                      v-bind="field">
                    <label class="form-check-label" for="hours_requirement">{{ $t('requirements_section.program_hours_credited') }}</label>
                  </div>
                  <div class="invalid-feedback" :id="`${$t('requirements_section.mandatory_skills')}_error` || `${$t('requirements_section.program_hours_credited')}_error` " v-if="errors[0]">
                    <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                    {{ $t('tracking_section.alert') }}
                  </div>  
                </Field>
              </div>
            </fieldset>
          </fieldset> 

          <div v-if="Object.keys(errors).length > 0 && showErrorBanner" class="alert alert-danger" role="alert">
            <span class="red mr-2">
              <font-awesome-icon :icon="['far', 'exclamation-circle']"/>
            </span>
            {{ $t('error_warning') }}
          </div>

          <div class="btn-row d-flex">
            <template v-if="type=='new'">
              <button type="submit" class="btn btn-primary btn-success no-shadow" v-if="programStandard.status == 'true'" :data-confirm="$t('active_alert')" >
                <font-awesome-icon :icon="['fa', 'save']" />
                {{ $t('create') }}
              </button>
              <button type="submit" class="btn btn-primary btn-success no-shadow" v-else >
                <font-awesome-icon :icon="['fa', 'save']" />
                {{ $t('create') }}
              </button>
            </template>
            
            <template v-else>
              <button  type="submit" class="btn btn-primary btn-success no-shadow" v-if="programStandard.status == 'true'" :data-confirm="$t('active_alert')">
                <font-awesome-icon :icon="['fa', 'save']" />
                {{ $t('submit') }}
              </button>
              <button  type="submit" class="btn btn-primary btn-success no-shadow" v-else >
                <font-awesome-icon :icon="['fa', 'save']" />
                {{ $t('submit') }}
              </button>
            </template>

            <a class="btn btn-light ml-auto" :href="cancel_path">
              <font-awesome-icon :icon="['fa', 'times']" />
              {{ $t('cancel') }}
            </a>
          </div>
      </Form>
    </div>
</template>
<script>
  import flash from '../../../../shared/flash_messages/components/Flash.vue';
  import '../../../../../javascripts/application/vee-validate-rules.js'
  import { sendAjaxRequest, ajaxResponseMessage } from '../../../../shared/typescripts/ajax.ts'
  import { setErrorMessage } from '../../../../shared/typescripts/error.ts'
  import { Form, Field } from 'vee-validate'

  export default {
    components: { flash, Form, Field },

    props: {
      locale: String,
      program_standard: String,
      load_path: String,
      cancel_path: String,
      type: String,
      first: Boolean,
    },

    data(){
      return{
        programStandard: {
          version: '',
          class_hours: 0,
          job_hours: 0,
          status: false,
          hours_tracking: true,
          skills_tracking: true,
          hours_requirement: false,
          skill_requirement: false
        },
        message_text: [],
        message_type: "",
        responses: [],
        errors: {},
        showErrorBanner: false,
      };
    },
    created(){
      this.$i18n.locale = this.locale;
    },
    mounted() {
      try {
        this.programStandard = JSON.parse(this.program_standard)
      }
      catch(err) {
        this.error = true; 
      }
      this.programStandard.status = ((this.programStandard.program_standard_status && this.programStandard.program_standard_status.active) || this.first).toString()
    },

    computed: {
      getTotalHours: function(){
        return parseInt(this.programStandard.class_hours || 0 ) + parseInt(this.programStandard.job_hours || 0);
      },
    },

    methods: {
      isHoursDisabled(){
        if(this.programStandard.hours_tracking){
          this.programStandard.hours_requirement = false;
        } 
      },
      isSkillsDisabled(val){
        if(this.programStandard.skills_tracking){
          this.programStandard.skill_requirement = false;
        }
      },

      submitUserInput(event){
        let payload = []
    
        payload = { program_standard: this.programStandard }

        // We need to add the status seperately so we can make sure it is a boolean for the controller
        payload.program_standard.status = this.programStandard.status == 'true'

        this.message_text = [];
        let send_type = this.type == "edit" ?  "PUT" : 'POST'

        sendAjaxRequest(send_type, this.load_path, 'json', payload, this.ajaxSuccess, this.throwError)
      },

      ajaxSuccess(response) {
        if (response.error){
          this.message_type = "error";
          this.message_text.push(response.error)
        }
        else {
          window.location.replace(response.path);
        }
      },

      throwError() {
        console.log("Error")
      },

      setErrorMessage({ valuese, errors, results }) {
        setErrorMessage(this, errors, true)
      }
    }
  }
</script>
